/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FolderWrapperWrapper_viewer = {
    readonly id: string;
    readonly " $fragmentRefs": FragmentRefs<"FolderWrapper_viewer">;
    readonly " $refType": "FolderWrapperWrapper_viewer";
};
export type FolderWrapperWrapper_viewer$data = FolderWrapperWrapper_viewer;
export type FolderWrapperWrapper_viewer$key = {
    readonly " $data"?: FolderWrapperWrapper_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"FolderWrapperWrapper_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "FolderWrapperWrapper_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "selectedItemIds",
      "type": "[String]",
      "defaultValue": []
    },
    {
      "kind": "LocalArgument",
      "name": "shouldFillInFolder",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "userIds",
      "type": "[String]",
      "defaultValue": []
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "FolderWrapper_viewer",
      "args": [
        {
          "kind": "Variable",
          "name": "selectedItemIds",
          "variableName": "selectedItemIds"
        },
        {
          "kind": "Variable",
          "name": "shouldFillInFolder",
          "variableName": "shouldFillInFolder"
        },
        {
          "kind": "Variable",
          "name": "userIds",
          "variableName": "userIds"
        }
      ]
    }
  ]
};
(node as any).hash = '366f7e74d597f4569f6a44f1637f2ecd';
export default node;
